import axiosInstance from '../axios'
import { withTimeout } from './pat-timeout'

/**
 * Lane-level pre-check, called once when the user clicks "GO" on Assign Inventory - before any
 * vehicle is known. Lets the caller learn "PAT has nothing to offer for this lane at all"
 * (overrideEligible: false) up front, instead of only finding that out vehicle-by-vehicle as each
 * one is assigned/edited via getSaleTypesEligibility above.
 */
export function getLaneSaleTypesEligibility(location, lane, weightClass, vehicleType) {
    return withTimeout(
        axiosInstance.get('/vehicle/saletypes-eligibility/lane', {
            params: { location, lane, weightClass, vehicleType }
        })
    )
}

export function getSaleTypesEligibility(vehicleList) {
    const validVehicleList = (vehicleList || []).filter(v => v && v.vin)
    if (validVehicleList.length === 0) {
        return Promise.resolve({ data: [] })
    }

    return withTimeout(
        axiosInstance.post('/vehicle/saletypes-eligibility', {
            vehicleList: validVehicleList
        })
    )
}

/**
 * Extracts a user-facing message from a failed sale type eligibility request (4xx/5xx/network/timeout),
 * so the error banner can show something more specific than a generic "Failed to load." when available.
 */
export function getPatErrorMessage(ex) {
    return ex?.response?.data?.error?.message
        || ex?.response?.data?.message
        || ex?.message
        || null
}
